export default __webpack_public_path__ + "static/media/image.a5b45ac5.png";